import { buildBaseContactParameters } from '../buildCommonContactParameters'
import type { ContactSubscriptionData } from '../contactSubscriptionData'

type Parameters = {
  contactData: ContactSubscriptionData
  id: string | number
  country: string
  action: string
  doorToDoorPartnerChecklistCheckedTitles: Record<string, boolean>
  doorToDoorPartnerLeadSource: string
}

export const contactSaveParametersGeneration = (parameters: Parameters): URLSearchParams => {
  const options = buildBaseContactParameters(parameters)

  const { professional: { taxId } } = parameters.contactData

  options.append('pro_tax_id', taxId || '')

  return options
}
